import styled from "styled-components";
import EStatusColors from "../../enums/status-colors";

interface ContainerProps {
  isVisible: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: ${props => props.isVisible ? "block" : "none"};
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  box-shadow: rgba(0, 0, 0, 0.15) -3px 3px 5px 0px;
  border-left: 6px solid rgb(31, 41, 156);
  width: calc(33% - 10px);
  min-height: 150px;
  background-color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardHeader = styled.div`
  display: flex;
  padding: 10px 10px 5px;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const CardTitle = styled.span`
  color: rgba(0, 0, 0, 0.87);
  font-size: 20px;
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const CardContentWrapper = styled.div`
  padding: 5px 10px 10px 10px;
`;

export const Link = styled.a`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  font-size: 14px;
  color: rgb(31, 41, 156);
  transition: none;

  &:hover {
    color: rgba(31, 41, 156, .7);
  }
`;

export const CardList = styled.ul`
  display: flex;
  list-style-type: none;
  padding: 0;
  flex: 1;
  justify-content: space-between;
`;

interface IProps {
  bgColor: string;
}

export const CardListItem = styled.li<IProps>`
  background-color: ${(props) => props.bgColor || "#37b394"};
  color: #fff;
  font-size: 18px;
  flex: 1;
  display: flex;
  margin: 0 5px;
  padding: 5px;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  position: relative;
  user-select: none;

  span {
    transition: none;
    background-color: #000000DE;
    color: #fff;
    padding: 5px 8px;
    font-size: 14px;
    border-radius: 5px;
    z-index: 999;
    position: absolute;
    top: -110%;
    visibility: hidden;

    div {
      transition: none;
      width: 0;
      height: 0;
      transform: translateX(50%);
      right: 50%;
      border-style: solid;
      border-width: 10px 10px 0 10px;
      background-color: transparent;
      border-color: #000000DE transparent transparent transparent;
      position: absolute;
    }
  }
  :hover {
    span {
      visibility: visible;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
`;

export const ErrorWrapper = styled.div`
  background-color: ${EStatusColors.ERRO};
  color: #fff;
  padding: 10px;
  text-wrap: wrap;
  font-size: 12px;
  border-radius: 3px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ErrorRow = styled.div``;

export const ErrorTitle = styled.h4`
  margin: 0;
`;

export const ErrorMessage = styled.div``;
